<template>
  <el-menu v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </el-menu>
</template>
<script>
export default {
  name: "aia-menu"
};
</script>